import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import {buttonType} from '../../../utils/commonPropTypes'
import WidthContainer from '../../../components/WidthContainer'
import {QueryedButton} from '../../../components/Button'
import StarsContainer from '../../../components/Stars'

import illustration from '../images/introIllustration.svg'

const PhoneBreakpoint = '@media only screen and (max-width: 1000px)'

const RootContainer = styled.div`
	position: relative;
`

const InnerContainer = styled(WidthContainer)`
	display: flex;
	justify-content: space-between;
	position: relative;
	
	${PhoneBreakpoint} {
		flex-direction: column-reverse;
		align-items: center;
		margin-bottom: 3rem;
	}
`

const LeftBlock = styled.div`
	max-width: 26.875rem;
	width: 100%;
`

const AboveTitle = styled.div`
	font-size: ${props => props.theme.fontSizes.big18};
	font-weight: ${props => props.theme.fontWeights.medium};
	margin-bottom: 1.2rem;
`

const Title = styled.h1`
	margin-bottom: 3rem;
`

const Text = styled.div`
	margin-bottom: 3rem;
`

const Buttons = styled.div`
	margin: -0.5rem -1rem;
	a {
		margin: 0.5rem 1rem;
	}
`

const Illustration = styled.img`
	width: 31rem;
	height: auto;
	${PhoneBreakpoint} {
		max-width: 20rem;
		width: 100%;
	}
`

Illustration.defaultProps = {
	src: illustration,
	alt: '',
}

const Stars = styled(StarsContainer)`
	position: absolute;
	top: 0;
	margin: 0 auto;
`

Stars.defaultProps = {
	width: '60rem',
}

const IntroSection = ({className, data}) => {
	const {aboveTitle, title, belowTitle, leftButton, rightButton} = data
	return <RootContainer className={className}>
		<Stars/>
		<InnerContainer>
			<LeftBlock>
				<AboveTitle>{aboveTitle}</AboveTitle>
				<Title>{title}</Title>
				<Text>{belowTitle}</Text>
				<Buttons>
					<QueryedButton data={leftButton}/>
					<QueryedButton inverted data={rightButton}/>
				</Buttons>
			</LeftBlock>
			<Illustration/>
		</InnerContainer>
	</RootContainer>
}

IntroSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		aboveTitle: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		belowTitle: PropTypes.string.isRequired,
		leftButton: buttonType.isRequired,
		rightButton: buttonType.isRequired,
	}).isRequired,
}

IntroSection.defaultProps = {
	className: '',
}

export default IntroSection
